import { useEffect, useState } from 'react';

// Devuelve si la media query se cumple y se actualiza al redimensionar la ventana.
// Uso: const isMobile = useMediaQuery('(max-width: 1270px)');
export default function useMediaQuery(query) {
  const [matches, setMatches] = useState(() => {
    if (typeof window !== 'undefined') {
      return window.matchMedia(query).matches;
    }
    return false;
  });

  useEffect(() => {
    const handler = () => {
      setMatches(window.matchMedia(query).matches);
    };
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, [query]);

  return matches;
}
